var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSingleBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 11,
    height: 10,
    viewBox: "0 0 11 10",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_10843",
    "data-name": "Group 10843",
    transform: "translate(-340 -297)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2058",
    "data-name": "Rectangle 2058",
    width: 11,
    height: 2,
    rx: 1,
    transform: "translate(340 297)",
    fill: "#2e80c0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2059",
    "data-name": "Rectangle 2059",
    width: 11,
    height: 2,
    rx: 1,
    transform: "translate(340 301)",
    fill: "#2e80c0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2060",
    "data-name": "Rectangle 2060",
    width: 11,
    height: 2,
    rx: 1,
    transform: "translate(340 305)",
    fill: "#2e80c0"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSingleBlue);
export default __webpack_public_path__ + "static/media/SingleBlue.63fcd8fc0d2b74414fe77be6eac7ddbc.svg";
export { ForwardRef as ReactComponent };